import * as api from '../api'

// Action Creators
export const getCompany = () => async (dispatch) => {
  try {
    const { data } = await api.fetchCompany()
    dispatch({ type: 'FETCH_COMPANY_INFORMATION', payload: data })
  } catch (error) {
    console.log(error.message)
  }
}

export const updateCompanyInfo = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.updateCompany(id, formData)

    if (data.success) {
      dispatch({ type: 'UPDATE_COMPANY_INFORMATION', payload: data.company })
      return { success: true }
    } else {
      return { success: false, message: data.message || 'Update failed' }
    }
  } catch (error) {
    console.log(error.message)
    return {
      success: false,
      message:
        error.response?.data?.message || error.message || 'Update failed',
    }
  }
}
